import React, { useState, useCallback } from "react";

import Content from "./Content";
import LoadingScreen from "./LoadingScreen";

export default function App() {
  const [booted, setBooted] = useState(false);
  const handleBoot = useCallback(() => setBooted(true), []);

  return (
    <div className="max-w-screen overflow-x-hidden">
      {!booted ? <LoadingScreen onDone={handleBoot} /> : null}
      <div
        className={booted ? undefined : "invisible"}
        aria-hidden={!booted}
      >
        <Content booted={booted} />
      </div>
      {/* {isMobile ? (
        <Content />
      ) : (
        <ReactFullpage
          licenseKey={"8B7C030B-08524C75-98A40180-96E13ACF"}
          scrollingSpeed={1000}
          render={({ state, fullpageApi }) => {
            return (
              <ReactFullpage.Wrapper>
                <Content />
              </ReactFullpage.Wrapper>
            );
          }}
        />
      )} */}
    </div>
  );
}
